import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { brokerageLogo } from "../redux/home/actions";

const HeaderNewMenuGuest = ({}) => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  let uId = params.get("uid");
  const [logo, setLogo] = useState();

  const brokerageLogoResponse = useSelector(
    (state) => state.home.brokerageLogo
  );

  useEffect(() => {
    if (!_.isEmpty(brokerageLogoResponse)) {
      if (brokerageLogoResponse?.status === "success") {
        console.log("logo", brokerageLogoResponse);
        setLogo(brokerageLogoResponse?.payload?.payload);
      }
    }
  }, [brokerageLogoResponse]);

  const dispatch = useDispatch();
  useEffect(() => {
    getBrokerageLogoFunc();
  }, [uId]);

  const getBrokerageLogoFunc = () => {
    let uid = atob(uId);
    // dispatch(
    //   brokerageLogo({
    //     module: "getBrokerageLogo",
    //     postData: {
    //       user_id: uid,
    //     },
    //   })
    // );
  };

  return (
    <>
      <div className="h-4">
        <div className="header-borderThin position-fixed w-100"></div>
      </div>

      <nav className={"navbar navbar-expand-lg guest-header"}>
        <div className="bg-menu-guest-lightWhite w-100">
          <div className="container d-flex h-100 align-items-center justify-content-between">
            <div className="">
              <div
                className="content-logo"
                onClick={() => {
                  window.scrollTo(0, 0);
                }}
              >
                {logo ? (
                  <a className="cursor-pointer">
                    <img
                      className="niit_logo"
                      src={logo}
                      alt="Brokerage Logo"
                    />
                  </a>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default HeaderNewMenuGuest;
